export const featureFlagsCommunication:Record<string, boolean> = {
  
}
